import { ApolloCache, gql, Reference } from "@apollo/client";

export const CREATE_ASSESSMENT_ATTEMPT = gql`
  mutation CreateAssessmentAttempt($assessmentAttemptInput: MembershipCreateAssessmentAttemptInput!) {
    createAssessmentAttempt(assessmentAttemptInput: $assessmentAttemptInput) {
      success
      message
      assessmentAttempt {
        score
        status
        creditCategory
      }
      hasAttemptsRemaining
    }
  }
`;

export const UPDATE_WATCH_PROGRESS = gql`
  mutation UpdateWatchProgress($videoId: ID!, $position: Int!, $watched: Boolean!) {
    updateWatchProgress(videoId: $videoId, position: $position, watched: $watched) {
      success
      message
    }
  }
`;

export const GET_WATCH_PROGRESS = gql`
  query GetWatchProgress($videoId: ID!) {
    getWatchProgress(videoId: $videoId) {
      position
      watched
    }
  }
`;

export const GET_VIDEO_DETAILS = gql`
  query GetVideoDetails($videoId: ID!) {
    videos(id: $videoId) {
      id
      title
      description
      series
      publishedAt
      expiredAt
      creditCategory
      url
      duration
      durationInSeconds
      assessment {
        id
        questions {
          id
          content
          position
          options {
            id
            content
            position
          }
        }
      }
      assessmentAttempts {
        status
        createdAt
      }
      memberVideoStatus
      watchProgress {
        position
        watched
      }
    }
  }
`;

export function setNewWatchProgress(cache: ApolloCache<any>, videoId: string, position: number, watched: boolean) {
  updateMemberVideoStatus(cache, videoId, position);
  cache.modify({
    id: cache.identify({ __typename: "MembershipVideo", id: videoId }),
    fields: {
      watchProgress(previous: any) {
        return { ...previous, position, watched };
      },
    },
  });
}

function updateMemberVideoStatus(cache: ApolloCache<any>, videoId: string, position: number) {
  if (position <= 0) return;

  cache.modify({
    id: cache.identify({ __typename: "MembershipVideo", id: videoId }),
    fields: {
      memberVideoStatus(previous: any) {
        if (typeof previous === "string" && ["Completed", "Unavailable", "In Progress"].includes(previous)) {
          return previous;
        }
        return "In Progress";
      },
    },
  });
}

export function updateMemberVideoStatusOnAssessmentAttempt(
  cache: ApolloCache<any>,
  videoId: string,
  hasAttemptsRemaining: boolean,
  status: string
) {
  cache.modify({
    id: cache.identify({ __typename: "MembershipVideo", id: videoId }),
    fields: {
      memberVideoStatus(previous: any) {
        if (status === "passed") {
          return "Completed";
        } else if (!hasAttemptsRemaining) {
          return "Unavailable";
        }
        return previous;
      },
    },
  });
}

export function updateAssessmentAttempts(cache: ApolloCache<any>, status: string, videoId: string) {
  const assessmentAttempt = {
    status,
    createdAt: new Date().toISOString(),
    __typename: "MembershipAssessmentAttempt",
  };

  cache.modify({
    id: cache.identify({ __typename: "MembershipVideo", id: videoId }),
    fields: {
      assessmentAttempts(existing: readonly any[] | Reference = []) {
        if (existing && Array.isArray(existing)) {
          return [...existing, assessmentAttempt];
        }

        return [assessmentAttempt];
      },
    },
  });
}
